import React, { useState, useEffect } from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { getParentMenuItems } from '../../components/layout/ParentMenuConfig';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import Button from '../../components/common/Button';
import { showToast } from '../../components/common/Toaster';
import { useTheme } from '../../contexts/ThemeContext';
import { parentStudentAPI } from '../../api/parentEndpoints';
import ActionableInsights from './analytics/ActionableInsights';
import {
  AnalyticsContainer,
  AnalyticsHeader,
  StudentSelector,
  LoadingContainer,
  EmptyState,
} from './Analytics.styles';

const InsightsPage = () => {
  const { theme } = useTheme();
  const [loading, setLoading] = useState(true);
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);

  const menuItems = getParentMenuItems();

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      setLoading(true);
      const response = await parentStudentAPI.getStudents();
      const studentsList = response.data.students || [];
      setStudents(studentsList);
      
      if (studentsList.length > 0) {
        setSelectedStudent(studentsList[0].id);
      }
    } catch (error) {
      showToast('error', 'Failed to load students');
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStudentChange = (e) => {
    setSelectedStudent(e.target.value);
  };

  if (loading) {
    return (
      <DashboardLayout menuItems={menuItems}>
        <LoadingContainer>
          <LoadingSpinner size="large" text="Loading..." />
        </LoadingContainer>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout menuItems={menuItems}>
      <AnalyticsContainer>
        <AnalyticsHeader>
          <div>
            <h1><FiAlertCircle style={{ marginRight: '12px' }} />Actionable Insights</h1>
            <p>Get alerts, recommendations, and personalized learning tips</p>
          </div>
          
          <StudentSelector>
            {students.length > 0 && (
              <>
                <label htmlFor="student-select" style={{ color: theme.colors.textSecondary }}>
                  Student:
                </label>
                <select 
                  id="student-select"
                  value={selectedStudent || ''} 
                  onChange={handleStudentChange}
                >
                  {students.map(student => (
                    <option key={student.id} value={student.id}>
                      {student.username} - {student.grade}
                    </option>
                  ))}
                </select>
              </>
            )}
          </StudentSelector>
        </AnalyticsHeader>

        {students.length === 0 ? (
          <EmptyState>
            <FiAlertCircle size={64} />
            <h3>No Students Added</h3>
            <p>Add students to view actionable insights</p>
            <Button onClick={() => window.location.href = '/parent/students'}>
              Add Student
            </Button>
          </EmptyState>
        ) : selectedStudent ? (
          <ActionableInsights studentId={selectedStudent} />
        ) : null}
      </AnalyticsContainer>
    </DashboardLayout>
  );
};

export default InsightsPage;

